var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0131,
    cy: 44.0131,
    r: 44.0131,
    fill: "url(#paint0_linear_1355_1146)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_1146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9523 26.2812C47.0443 26.3033 47.0443 26.3033 47.1382 26.3258C49.6064 26.928 51.7095 28.2131 53.4913 30.0078C53.526 30.0427 53.5607 30.0775 53.5964 30.1135C55.9476 32.5108 57.0961 35.9338 57.0948 39.2434C57.0127 44.5873 53.7325 49.7704 50.8194 54.0547C50.7621 54.1394 50.7621 54.1394 50.7036 54.2259C49.9332 55.3645 49.123 56.47 48.2733 57.5505C48.1014 57.7698 47.9309 57.9902 47.7604 58.2106C47.2043 58.9284 46.6337 59.6321 46.0446 60.3232C45.834 60.5708 45.6298 60.8227 45.4273 61.0771C45.1438 61.4259 44.8295 61.7957 44.421 62C44.2866 62.0122 44.1516 62.0188 44.0167 62.0219C43.9446 62.0246 43.8724 62.0272 43.7981 62.0299C43.3337 61.9669 43.0447 61.6252 42.7467 61.2924C42.7099 61.2519 42.6731 61.2114 42.6351 61.1696C42.3646 60.8694 42.1051 60.5614 41.8521 60.2463C41.7196 60.0818 41.5858 59.919 41.4506 59.7568C41.0056 59.2228 40.5732 58.6833 40.16 58.1242C39.9239 57.8055 39.6791 57.4956 39.4288 57.188C39.014 56.6761 38.6362 56.1415 38.2608 55.6004C38.1728 55.4747 38.0836 55.35 37.9935 55.2258C34.9729 51.0637 31.8784 46.1398 31.0616 40.9765C31.0535 40.9256 31.0454 40.8747 31.037 40.8222C30.5429 37.5965 31.387 34.1072 33.3045 31.4681C33.3532 31.4039 33.402 31.3396 33.4523 31.2734C33.4967 31.2142 33.5411 31.155 33.5868 31.0941C35.4806 28.6508 38.0468 27.0087 41.046 26.2812C41.1053 26.2663 41.1646 26.2514 41.2257 26.2361C43.0428 25.7969 45.1425 25.8285 46.9523 26.2812ZM39.4991 34.2968C39.4544 34.3356 39.4098 34.3744 39.3637 34.4144C38.1406 35.5503 37.5519 37.2344 37.4469 38.8603C37.4037 40.6986 38.1559 42.3545 39.392 43.6855C40.2462 44.5225 41.2984 45.0953 42.4523 45.4062C42.5082 45.422 42.5641 45.4378 42.6217 45.454C44.2288 45.8259 46.0117 45.485 47.4068 44.6281C48.9263 43.6181 49.9786 42.1975 50.3976 40.414C50.7403 38.6987 50.4523 36.911 49.4721 35.4398C48.3797 33.8924 46.9034 32.9674 45.0686 32.5665C42.9658 32.3107 41.0886 32.8918 39.4991 34.2968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_1146",
    x1: 44.0131,
    y1: -101.675,
    x2: 44.0131,
    y2: 88.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA4A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_1146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(26 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIcon);
export default __webpack_public_path__ + "static/media/locIcon.8dfe9c8dd0ae957a957a8564f03758d4.svg";
export { ForwardRef as ReactComponent };